var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "item",
      on: {
        click: function ($event) {
          return _vm.goTeamDetail(
            _vm.$route.query,
            _vm.itemData.teamId,
            _vm.$route.query,
            _vm.pageBtnStatusDto.btnInnerStatus
          )
        },
      },
    },
    [
      _c("img", { attrs: { src: _vm.itemData.imgUrl } }),
      _c(
        "span",
        { staticClass: "right-box" },
        [
          _c(
            "h4",
            {
              staticClass: "team-name nowrap",
              attrs: { title: _vm.itemData.teamName },
            },
            [_vm._v(" " + _vm._s(_vm.itemData.teamName) + " ")]
          ),
          _c("span", { staticClass: "leader nowrap" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("planLxDetail.DZ")) +
                "：" +
                _vm._s(_vm.itemData.leaderName) +
                " "
            ),
          ]),
          _vm.planDto.status == 1 && _vm.itemData.processStatus === 1
            ? _c("el-progress", {
                attrs: {
                  "stroke-width": 10,
                  percentage: _vm.itemData.processDto.percent
                    ? Number(_vm.itemData.processDto.percent)
                    : 0,
                },
              })
            : _c(
                "div",
                {
                  staticClass: "status-type nowrap",
                  class: {
                    success: _vm.itemData.createStatus == 1,
                    ing: _vm.itemData.createStatus == 0,
                  },
                },
                [
                  _c("span", { staticClass: "dian" }),
                  _c(
                    "span",
                    {
                      attrs: {
                        title:
                          _vm.itemData.createStatus == 1
                            ? _vm.itemData.processStatus == 2
                              ? _vm.$t("planLxDetail.YJJ")
                              : _vm.$t("planLxDetail.YJX")
                            : _vm.$t("planLxDetail.ZJZ"),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.itemData.createStatus == 1
                              ? _vm.itemData.processStatus == 2
                                ? _vm.$t("planLxDetail.YJJ")
                                : _vm.$t("planLxDetail.YJX")
                              : _vm.$t("planLxDetail.ZJZ")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }